import { CurrencySchema, CustomerSchema, InvoiceSchema } from '@weft/types';
import { oz } from '@weft/utils';
import { OUTSTANDING_BREAKDOWN_OPTIONS } from './outstanding-breakdown-options';

export const GetArAgingReportResponseSchema = oz.object({
  settings: oz.object({
    currency: CurrencySchema,
  }),
  summary: oz.array(oz.object({
    customer: CustomerSchema.pick({
      id: true,
      name: true,
    }),
    outstandingBreakdown: oz.record(oz.nativeEnum(OUTSTANDING_BREAKDOWN_OPTIONS), oz.object({
      grossAmount: oz.number(),
      invoicesCount: oz.number(),
    })),
  })),
  summaryBreakdown: oz.array(oz.object({
    invoice: InvoiceSchema.pick({
      id: true,
      revenueBreakdown: true,
      paymentDueDays: true,
      billingCycle: true,
      billingStatus: true,
      paymentTerm: true,
    }),
    customer: CustomerSchema.pick({
      id: true,
      name: true,
    }),
    daysOutstanding: oz.number(),
  })),
});

export type GetArAgingReportResponse = oz.infer<typeof GetArAgingReportResponseSchema>;